import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/mobile-menu/categories/mobile-menu__seg-touring.svg")